import styled from 'styled-components';
import Button from '../Button';

export const PolicyDocView = styled.div`
  width: 100%;
  max-height: 350px;
  overflow: auto;
  padding-top: 15px;
  padding-right: 15px;

  @media (max-width: 768px) {
    max-height: 68vh;
  }
`;

export const RegisteredSuccessView = styled.div`
  margin: auto;
  text-align: center;
  width: 58%;
  display: grid;
  top: -20px;
  position: relative;

  svg {
    color: #2bae4e;
    margin: 30px auto;
  }

  label {
    color: #2bae4e;
    margin-bottom: 10px;
  }

  button {
    margin-bottom: 24px !important;
    margin-top: 10px !important;

    @media (max-width: 768px) {
      display: none;
    }
  }

  @media (max-width: 420px) {
    width: 100%;
  }
`;

export const StoreInfoBox = styled.div`
  .store-row {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 13px;

    img {
      height: 53px;
    }

    img[alt='qrCode'] {
      height: 90px;
    }

    p {
      font-size: 0.75rem;
      color: gray;
      margin-left: 10px;
      text-align: left;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const IconTooltip = styled.a`
  margin-top: 8px;
  margin-bottom: 20px;
  align-items: center;
  display: flex;

  svg {
    display: flex;
    color: #000000;
    margin-left: 5px;
  }

  &:hover + .__react_component_tooltip {
    visibility: visible !important;
    opacity: 1 !important;
  }
`;

export const DescriptionContent = styled.div`
  display: flex;

  .__react_component_tooltip {
    pointer-events: auto !important;
    left: 19px !important;
    width: 91%;
    box-shadow: 4px -1px 11px -3px #0000006b;
    opacity: 1 !important;
    border-radius: 12px;

    a {
      color: #000000;
      text-decoration: underline;
    }

    &:hover {
      visibility: visible !important;
      opacity: 1 !important;
    }
  }
`;

export const ButtonMobileView = styled.a`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const SignupModalContainer = styled.div`
  margin-bottom: 20px;
`;

export const BackButton = styled(Button).attrs(() => ({
  title: 'Voltar',
  classType: 'fat big outline',
}))`
  min-height: 47px;
  width: 90%;
  margin: 15px auto 0;
  background: transparent;
  color: var(--color-btn-orange);
  border: none;
`;
